/* eslint-disable */

import { useRecoilState, useRecoilValue, useRecoilValueLoadable } from 'recoil'
import { MutualFundsSIPs } from '../../store/MFStore'
import { useEffect, useRef, useState } from 'react'
import { Button } from '../../Components/ui/button'
import MFOrdersSkeleton from '../../Components/SkeletonLoaders/MFOrdersSkeleton'
import NoBond from '../../assets/images/nodata.svg'
import { useNavigate } from 'react-router-dom'
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '../../Components/ui/accordian'
import env from '../../env/env'
import { toCurrency } from '../../utils/CurrencyUtil'
import {
  addNumberSuffix,
  capitalizeWords,
  FinancialGoalsReversed,
  monthShortNames,
} from '../../utils/Util'
import { Card, CardContent, CardHeader, CardTitle } from '../../Components/ui/card'
import { MoreHorizontal } from 'lucide-react'

import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from '../../Components/ui/menubar'
import IconsSelector from '../../store/IconsStore'
import { Separator } from '../../Components/ui/separator'
import { post } from '../../http/restservice'
import { userDetailsState } from '../LoginState'
import { useModal } from '../../hooks/use-modal-store'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../Components/ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../Components/ui/select'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../Components/ui/tabs2'
import SIPsEmpty from '../../Components/EmptyState/SIPsEmpty'

const BasketSIPs = () => {
  const sips = useRecoilValueLoadable(MutualFundsSIPs)
  const [activeSips, setActiveSips] = useState(null)
  const [inProgressSips, setInProgressSips] = useState(null)
  const [cancelledSips, setCancelledSips] = useState(null)
  const [cancelledSipsCount, setCancelledSipsCount] = useState(0)
  const [activeSipsCount, setActiveSipsCount] = useState(0)
  const [inProgressSipsCount, setInProgressSipsCount] = useState(0)
  const iconsList = useRecoilValue(IconsSelector)
  const [openMenubar, setOpenMenubar] = useState(null)
  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)
  const userData = JSON.parse(localStorage.getItem('userData'))
  const clientCode = userDetails ? userDetails?.uid?.split('-')[0] : userData?.uid?.split('-')[0]
  const { onOpen } = useModal()
  const { showError } = useErrorPopup()
  const [showSIPCancel, setShowSIPCancel] = useState(false)
  const [selectedReason, setSelectedReason] = useState('')
  const [selectedSIP, setSelectedSIP] = useState([])
  console.log('🚀 ~ BasketSIPs ~ selectedSIP:', selectedSIP)

  // Swipe-to-cancel state at basket (accordion header) level for Active SIPs
  const [basketSwipeOffsets, setBasketSwipeOffsets] = useState({}) // basketId -> offsetX
  const touchStartXRef = useRef({}) // basketId -> startX
  const isDraggingRef = useRef(false)
  const ACTIVE_OPEN_THRESHOLD = -80 // px to reveal action
  const ACTIVE_FULL_THRESHOLD = -160 // px to auto-open modal

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

  const handleTouchStart = (e, basketId) => {
    // Only start on single touch
    if (!e.touches || e.touches.length !== 1) return
    touchStartXRef.current[basketId] = e.touches[0].clientX
    isDraggingRef.current = true
  }

  const handleTouchMove = (e, basketId) => {
    if (!isDraggingRef.current || !touchStartXRef.current[basketId]) return
    const currentX = e.touches[0].clientX
    const deltaX = currentX - touchStartXRef.current[basketId]
    // We only allow right-to-left swipe (negative offset)
    const nextOffset = clamp(deltaX, -200, 0)
    setBasketSwipeOffsets((prev) => ({ ...prev, [basketId]: nextOffset }))
  }

  const resetSwipe = (basketId) => {
    setBasketSwipeOffsets((prev) => ({ ...prev, [basketId]: 0 }))
    delete touchStartXRef.current[basketId]
    isDraggingRef.current = false
  }

  const handleTouchEnd = (sips, basketId) => {
    const offset = basketSwipeOffsets[basketId] || 0
    isDraggingRef.current = false
    delete touchStartXRef.current[basketId]

    if (offset <= ACTIVE_FULL_THRESHOLD) {
      // Open cancel modal directly on full swipe
      // Use first sip in the basket for cancellation context
      setSelectedSIP(sips)
      setShowSIPCancel(true)
      setBasketSwipeOffsets((prev) => ({ ...prev, [basketId]: 0 }))
      return
    }

    if (offset <= ACTIVE_OPEN_THRESHOLD) {
      // Keep action revealed
      setBasketSwipeOffsets((prev) => ({ ...prev, [basketId]: -96 }))
    } else {
      // Snap back
      setBasketSwipeOffsets((prev) => ({ ...prev, [basketId]: 0 }))
    }
  }

  const cancellationReasons = [
    { code: '01', description: 'Non availability of Funds' },
    { code: '02', description: 'Scheme not performing' },
    { code: '03', description: 'Service issue' },
    { code: '04', description: 'Load Revised' },
    { code: '05', description: 'Wish to invest in other schemes' },
    { code: '06', description: 'Change in Fund Manager' },
    { code: '07', description: 'Goal Achieved' },
    { code: '08', description: 'Not comfortable with market volatility' },
    { code: '09', description: 'Will be restarting SIP after few months' },
    { code: '10', description: 'Modifications in bank/mandate/date etc' },
    { code: '11', description: 'I have decided to invest elsewhere' },
    { code: '12', description: 'This is not the right time to invest' },
  ]

  const handleCancel = () => {
    if (selectedReason) {
      setShowSIPCancel(false)
      handleSIPCancel()
    }
  }

  const handleSIPCancel = async () => {
    setOpenMenubar(null)

    const payload = {
      clientCode: clientCode?.toUpperCase(),
      registrationNumberList: selectedSIP?.map((sip) => sip.sipRegId),
      sipCancelReason: selectedReason.toString(),
    }

    const response = await post(`mutualfundservice/api/basket/multiBasketSipCancellation`, payload)

    const isAllSuccess = response?.basketSipCancellationResponse?.every(
      (item) => item.status === 'SUCCESS',
    )

    if (!response?.isError && isAllSuccess) {
      onOpen('openSIPPopup', {
        title: 'Cancellation Successful',
        message: 'Your cancellation has been done successfully.',
        severity: 'success',
      })

      setSelectedReason('')
    } else if (!response?.isError && !isAllSuccess) {
      showError(
        'SIP cancellation failed',
        'We were unable to initiate your SIP cancellation request. Please try again later or contact support if the issue persists.',
        () => {},
      )
      setSelectedReason('')
    }

    if (response?.isError) {
      showError(
        'SIP cancellation failed',
        'We were unable to initiate your SIP cancellation request. Please try again later or contact support if the issue persists.',
        () => {},
      )
      setSelectedReason('')
    }
  }

  useEffect(() => {
    if (sips?.state === 'hasValue' && sips?.contents?.data?.length > 0) {
      const groupedSIPs = sips?.contents?.data?.reduce((acc, sip) => {
        if (sip.customerBasketInvestmentId && sip.sipStatus === 'ACTIVE') {
          acc[sip.customerBasketInvestmentId] = acc[sip.customerBasketInvestmentId] || []
          acc[sip.customerBasketInvestmentId].push(sip)
        }
        return acc
      }, {})

      setActiveSips(groupedSIPs)
    }

    if (sips?.state === 'hasValue' && sips?.contents?.inProgressSipData?.length > 0) {
      // Flatten logic
      const flattenedSIPs = sips?.contents?.inProgressSipData?.flatMap((sipObj) =>
        sipObj.orderRequest?.sipData?.map((sip) => ({
          ...sipObj, // copy parent keys (like customerBasketInvestmentId, orderType, etc.)
          ...sipObj.orderRequest, // copy orderRequest keys
          ...sip, // copy individual SIP keys
        })),
      )

      // Remove nested arrays if not needed
      const result = flattenedSIPs?.map(({ sipData, orderRequest, ...rest }) => rest)

      setInProgressSipsCount(result?.length)

      const groupedSIPs = result?.reduce((acc, sip) => {
        if (sip.customerBasketInvestmentId) {
          // Initialize the array for this basket
          acc[sip.customerBasketInvestmentId] = acc[sip.customerBasketInvestmentId] || []

          acc[sip.customerBasketInvestmentId].push(sip)
        }
        return acc
      }, {})

      setInProgressSips(groupedSIPs)
    }

    if (sips?.state === 'hasValue' && sips?.contents?.data?.length > 0) {
      const groupedSIPs = sips?.contents?.data?.reduce((acc, sip) => {
        if (sip.customerBasketInvestmentId && sip.sipStatus === 'CANCELLED') {
          acc[sip.customerBasketInvestmentId] = acc[sip.customerBasketInvestmentId] || []
          acc[sip.customerBasketInvestmentId].push(sip)
        }
        return acc
      }, {})

      setCancelledSips(groupedSIPs)
    }
  }, [sips])

  const navigate = useNavigate()
  //   const refreshSIPs = useRecoilRefresher_UNSTABLE(MutualFundsSIPs)

  //   useEffect(() => refreshSIPs(), [])

  const calculateParcentage = (part, total) => {
    const result = (part / total) * 100
    return result ? parseFloat(result.toFixed(2)) : 0
  }

  const getTotalAmount = (sips) => {
    const sipTotal =
      sips.reduce((acc, sip) => acc + Number(sip.installmentAmt || sip.installmentAmount), 0) || 0

    return sipTotal
  }

  const getDate = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[0]
  }

  const getMonth = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[1]
  }

  const getYear = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[2]
  }

  const getActiveSipsInfo = (sips = []) => {
    return sips
      ?.filter((sip) => sip.customerBasketInvestmentId !== null)
      ?.reduce(
        (acc, item) => {
          if (item.sipStatus === 'ACTIVE') {
            acc.totalAmount += Number(item.installmentAmt) || 0
            acc.totalSIPCount += 1
          }
          return acc
        },
        { totalAmount: 0, totalSIPCount: 0 },
      )
  }

  const getCancelledSipsInfo = (sips = []) => {
    return sips
      ?.filter((sip) => sip.customerBasketInvestmentId !== null)
      ?.reduce(
        (acc, item) => {
          if (item.sipStatus === 'CANCELLED') {
            acc.totalAmount += Number(item.installmentAmt) || 0
            acc.totalSIPCount += 1
          }
          return acc
        },
        { totalAmount: 0, totalSIPCount: 0 },
      )
  }

  const getSipOverallStatus = (sips) => {
    const activeSipCount = sips?.reduce(
      (acc, sip) => (sip.sipStatus === 'ACTIVE' ? acc + 1 : acc),
      0,
    )

    if (activeSipCount === sips.length) {
      return 'Active'
    } else if (activeSipCount === 0) {
      return 'Cancelled'
    } else {
      return 'Partial'
    }
  }

  if (sips.contents.length === 0) {
    return (
      <SIPsEmpty
        title='There are no active basket SIPs right now.'
        description='Start your investment journey today by choosing a plan or exploring our curated funds.'
        mainText='Active Basket SIPs'
        page='/dashboard/mutual-funds'
        showButton={false}
      />
    )
  }

  switch (sips.state) {
    case 'loading':
      return (
        <div className='max-w-[1128px] mx-auto'>
          <MFOrdersSkeleton />
        </div>
      )

    case 'hasValue':
      return (
        <div className='bg-white min-h-screen'>
          {sips?.contents?.message?.toLowerCase() === 'no sip found for the specified user.' ? (
            <SIPsEmpty
              title='There are no active basket SIPs right now.'
              description='Start your investment journey today by choosing a plan or exploring our curated funds.'
              mainText='Active Basket SIPs'
              page='/dashboard/mutual-funds'
              showButton={false}
            />
          ) : (
            <>
              <div className='mb-4 px-2'>
                <div className='w-full mt-4 lg:max-w-2xl mx-auto px-6 py-4 rounded-xl md:rounded-3xl border text-nowrap bg-[#F4F7FE]'>
                  <div className='flex justify-between items-center space-x-6'>
                    <div className='space-y-1 flex-1'>
                      <p className='font-semibold text-black-500 text-lg'>
                        {getActiveSipsInfo(sips?.contents?.data)?.totalSIPCount}
                      </p>

                      <p className='text-sm font-medium text-black-400'>No. of active SIPs</p>
                    </div>
                    <Separator orientation='vertical' className='h-11' />

                    <div className='space-y-1 flex-1'>
                      <p className='font-semibold text-black-500 text-lg'>
                        ₹ {toCurrency(getActiveSipsInfo(sips?.contents?.data)?.totalAmount)}
                      </p>

                      <p className='text-sm font-medium text-black-400'>Active SIP amount</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='flex justify-center items-center w-full flex-col gap-6'>
                <Tabs defaultValue='active' className='w-full'>
                  <div className='px-2 flex justify-center items-center'>
                    <TabsList className='space-x-2'>
                      <TabsTrigger
                        value='active'
                        className=' text-secondary-500 data-[state=active]:bg-secondary-500 data-[state=active]:text-white'
                      >
                        Active ({getActiveSipsInfo(sips?.contents?.data)?.totalSIPCount})
                      </TabsTrigger>
                      <TabsTrigger
                        value='in-progress'
                        className='text-warning-500 data-[state=active]:bg-warning-500 data-[state=active]:text-white'
                      >
                        In-Progress ({inProgressSipsCount})
                      </TabsTrigger>
                      <TabsTrigger
                        value='cancelled'
                        className='text-error-500 data-[state=active]:bg-error-500 data-[state=active]:text-white'
                      >
                        Inactive ({getCancelledSipsInfo(sips?.contents?.data)?.totalSIPCount})
                      </TabsTrigger>
                    </TabsList>
                  </div>
                  <TabsContent value='active' className='w-full'>
                    <div className='max-w-[1128px] px-4 lg:px-0 mx-auto'>
                      {activeSips && Object.keys(activeSips).length > 0 ? (
                        <>
                          <div className='hidden md:flex justify-between bg-[#F4F7FE] rounded-lg pl-14'>
                            <div className='text-primary-400 text-sm font-medium py-3'>
                              Goal Name
                            </div>

                            <div className='text-primary-400 text-sm font-medium py-3 px-4 pr-20'>
                              Amount
                            </div>
                          </div>
                          <Accordion type='single' collapsible className='w-full'>
                            {Object.entries(activeSips).map(([basketId, sips]) => (
                              <AccordionItem value={basketId} key={basketId}>
                                <AccordionTrigger className='hover:no-underline'>
                                  <div className='relative w-full overflow-hidden'>
                                    <div className='absolute inset-y-0 right-0 w-24 h-10 rounded-md bg-error-500 flex items-center justify-center'>
                                      <button
                                        className='text-white text-sm font-semibold'
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setSelectedSIP(sips)
                                          setShowSIPCancel(true)
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>

                                    <div
                                      className='flex justify-between items-center w-full bg-white group'
                                      style={{
                                        transform: `translateX(${
                                          basketSwipeOffsets[basketId] || 0
                                        }px)`,
                                        transition: isDraggingRef.current
                                          ? 'none'
                                          : 'transform 200ms ease',
                                      }}
                                      onTouchStart={(e) => handleTouchStart(e, basketId)}
                                      onTouchMove={(e) => handleTouchMove(e, basketId)}
                                      onTouchEnd={() => handleTouchEnd(sips, basketId)}
                                    >
                                      <div className='w-full'>
                                        <div className='w-full flex md:justify-between items-start md:items-center gap-x-2'>
                                          <img
                                            src={
                                              iconsList[
                                                'light' + FinancialGoalsReversed[sips[0]?.planType]
                                              ]
                                                ? iconsList[
                                                    'light' +
                                                      FinancialGoalsReversed[sips[0]?.planType]
                                                  ]
                                                : `${env.SVGS}/basket.svg`
                                            }
                                            className='h-12 w-12 rounded-[8px] mt-1'
                                          />
                                          <div className='w-full'>
                                            <div className='flex justify-between gap-x-4 items-center'>
                                              <p className='font-semibold text-gray-900 text-wrap leading-6 flex items-center gap-x-2'>
                                                <span className='truncate whitespace-nowrap overflow-hidden max-w-[200px] md:max-w-max'>
                                                  {' '}
                                                  {sips[0]?.customerBasketName}
                                                </span>
                                              </p>
                                            </div>

                                            <p className='text-sm text-black-400'>
                                              Repeats on the{' '}
                                              <strong>
                                                {addNumberSuffix(getDate(sips[0]?.sipStartDate))}
                                              </strong>{' '}
                                              of every month
                                            </p>

                                            <div className='flex justify-between items-center'>
                                              <div className='flex gap-x-1 text-xs items-center text-black-400'>
                                                Start Date -
                                                <p className='flex justify-start text-xs items-center gap-x-1 text-center font-DMSans'>
                                                  <span className='font-semibold'>
                                                    {getDate(sips[0]?.sipStartDate)}
                                                  </span>
                                                  <span className='font-semibold '>
                                                    {
                                                      monthShortNames[
                                                        getMonth(sips[0]?.sipStartDate) - 1
                                                      ]
                                                    }
                                                  </span>
                                                  <span className='font-semibold '>
                                                    {getYear(sips[0]?.sipStartDate)}
                                                  </span>
                                                </p>
                                              </div>

                                              <p className='text-nowrap pr-2 md:hidden'>
                                                ₹ {toCurrency(getTotalAmount(sips))}
                                              </p>
                                            </div>
                                          </div>

                                          <div className='hidden md:flex relative overflow-hidden min-w-[120px]'>
                                            <div className='flex items-center transition-transform duration-300 ease-in-out group-hover:-translate-x-full'>
                                              <p className='text-nowrap pr-2'>
                                                ₹ {toCurrency(getTotalAmount(sips))}
                                              </p>
                                            </div>
                                            <div className='absolute right-2 top-1/2 -translate-y-1/2 flex items-center transition-transform duration-300 ease-in-out group-hover:translate-x-0 translate-x-[120%]'>
                                              <button
                                                className='text-sm font-semibold bg-error-500 hover:bg-error-600 text-white px-3 h-10 rounded-md transition-colors whitespace-nowrap'
                                                onClick={(e) => {
                                                  e.stopPropagation()
                                                  setSelectedSIP(sips)
                                                  setShowSIPCancel(true)
                                                }}
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </AccordionTrigger>

                                <AccordionContent>
                                  <div>
                                    {sips?.map((sip, index) => {
                                      return (
                                        <div
                                          className={`p-4 flex items-center lg:items-start w-full`}
                                          key={index}
                                        >
                                          <div className='flex justify-between items-center w-full'>
                                            <div className='flex justify-between items-center w-full'>
                                              <div className='w-full flex justify-between items-center gap-x-2'>
                                                <div className='flex gap-x-4 items-center md:w-[50%]'>
                                                  <img
                                                    src={`${env.MF_LOGOS_URL}/${sip?.amcCode}.png`}
                                                    className='h-12 w-12 rounded-[8px] mt-1'
                                                  />
                                                  <div className='w-full md:w-auto'>
                                                    <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                      {sip?.sname
                                                        ? sip.sname
                                                        : sip?.amfiName
                                                        ? sip.amfiName
                                                        : sip?.schemeName}
                                                      <span
                                                        className={`text-sm ${
                                                          capitalizeWords(sip?.sipStatus) ===
                                                          'Active'
                                                            ? 'text-secondary-500 bg-secondary-50 rounded-full px-2'
                                                            : capitalizeWords(sip?.sipStatus) ===
                                                              'Cancelled'
                                                            ? 'text-error-500 bg-error-50 rounded-full px-2'
                                                            : 'text-warning-500 bg-warning-50 rounded-full px-2'
                                                        }`}
                                                      >
                                                        {capitalizeWords(sip?.sipStatus)}
                                                      </span>{' '}
                                                    </p>
                                                  </div>
                                                </div>

                                                {sip?.installmentAmt && (
                                                  <p className='text-nowrap text-sm font-medium text-black-400 pr-16'>
                                                    {calculateParcentage(
                                                      sip?.installmentAmt,
                                                      getTotalAmount(sips),
                                                    )}{' '}
                                                    %
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            {/* <div className='ml-4'>
                                              <Menubar className='border-0 bg-transparent p-0'>
                                                <MenubarMenu>
                                                  <MenubarTrigger asChild>
                                                    <Button
                                                      variant='ghost'
                                                      size='sm'
                                                      className='h-6 w-6 p-0 rounded-full hover:bg-gray-100 cursor-pointer'
                                                      onClick={(e) => {
                                                        e.stopPropagation()
                                                        setOpenMenubar(
                                                          openMenubar === sip.id ? null : sip.id,
                                                        )
                                                      }}
                                                    >
                                                      <MoreHorizontal className='h-4 w-4' />
                                                    </Button>
                                                  </MenubarTrigger>
                                                  <MenubarContent align='end' className='w-48'>
                                                    <MenubarItem
                                                      className='text-error-500 bg-error-50 cursor-pointer'
                                                      onClick={() => {
                                                        setShowSIPCancel(true), setSelectedSIP(sip)
                                                      }}
                                                    >
                                                      Cancel SIP
                                                    </MenubarItem>
                                                  </MenubarContent>
                                                </MenubarMenu>
                                              </Menubar>
                                            </div> */}
                                          </div>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </AccordionContent>
                              </AccordionItem>
                            ))}
                          </Accordion>
                        </>
                      ) : (
                        <SIPsEmpty
                          title='There are no active basket SIPs right now.'
                          description='Start your investment journey today by choosing a plan or exploring our curated funds.'
                          mainText='Active Basket SIPs'
                          page='/dashboard/mutual-funds'
                          showButton={false}
                        />
                      )}
                    </div>
                  </TabsContent>
                  <TabsContent value='in-progress'>
                    <div className='max-w-[1128px] px-4 lg:px-0 mx-auto'>
                      {inProgressSips && Object.keys(inProgressSips).length > 0 ? (
                        <>
                          <div className='hidden md:flex justify-between bg-[#F4F7FE] rounded-lg pl-14'>
                            <div className='text-primary-400 text-sm font-medium py-3'>
                              Goal Name
                            </div>

                            <div className='text-primary-400 text-sm font-medium py-3 px-4'>
                              Amount
                            </div>
                          </div>
                          <Accordion type='single' collapsible className='w-full'>
                            {Object.entries(inProgressSips).map(([basketId, sips]) => (
                              <AccordionItem value={basketId} key={basketId}>
                                <AccordionTrigger className='hover:no-underline'>
                                  <div className='flex justify-between items-center w-full'>
                                    <div className='w-full'>
                                      <div className='w-full flex md:justify-between items-start md:items-center gap-x-2'>
                                        <img
                                          src={
                                            iconsList[
                                              'light' + FinancialGoalsReversed[sips[0]?.planType]
                                            ]
                                              ? iconsList[
                                                  'light' +
                                                    FinancialGoalsReversed[sips[0]?.planType]
                                                ]
                                              : `${env.SVGS}/basket.svg`
                                          }
                                          className='h-12 w-12 rounded-[8px] mt-1'
                                        />
                                        <div className='w-full'>
                                          <div className='flex justify-between gap-x-4 items-center'>
                                            <p className='font-semibold text-gray-900 text-wrap leading-6 flex items-center gap-x-2'>
                                              <span className='truncate whitespace-nowrap overflow-hidden max-w-[200px] md:max-w-max'>
                                                {' '}
                                                {sips[0]?.customerBasketName}
                                              </span>
                                            </p>
                                          </div>

                                          <p className='text-sm text-black-400'>
                                            Repeats on the{' '}
                                            <strong>
                                              {addNumberSuffix(getDate(sips[0]?.startDate))}
                                            </strong>{' '}
                                            of every month
                                          </p>

                                          <div className='flex justify-between items-center'>
                                            <div className='flex gap-x-1 text-xs items-center text-black-400'>
                                              Start Date -
                                              <p className='flex justify-start text-xs items-center gap-x-1 text-center font-DMSans'>
                                                <span className='font-semibold'>
                                                  {getDate(sips[0]?.startDate)}
                                                </span>
                                                <span className='font-semibold '>
                                                  {
                                                    monthShortNames[
                                                      getMonth(sips[0]?.startDate) - 1
                                                    ]
                                                  }
                                                </span>
                                                <span className='font-semibold '>
                                                  {getYear(sips[0]?.startDate)}
                                                </span>
                                              </p>
                                            </div>

                                            <p className='text-nowrap pr-2 md:hidden'>
                                              ₹ {toCurrency(getTotalAmount(sips))}
                                            </p>
                                          </div>
                                        </div>

                                        <div className='hidden md:flex'>
                                          <p className='text-nowrap pr-2'>
                                            ₹ {toCurrency(getTotalAmount(sips))}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </AccordionTrigger>

                                <AccordionContent>
                                  <div>
                                    {sips?.map((sip, index) => {
                                      return (
                                        <div
                                          className={`p-4 flex items-center lg:items-start w-full`}
                                          key={index}
                                        >
                                          <div className='flex justify-between items-center w-full'>
                                            <div className='flex justify-between items-center w-full'>
                                              <div className='w-full flex justify-between items-center gap-x-2'>
                                                <div className='flex gap-x-4 items-center md:w-[50%]'>
                                                  <img
                                                    src={`${env.MF_LOGOS_URL}/${sip?.amcCode}.png`}
                                                    className='h-12 w-12 rounded-[8px] mt-1'
                                                  />
                                                  <div className='w-full md:w-auto'>
                                                    <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                      {sip?.sname
                                                        ? sip.sname
                                                        : sip?.amfiName
                                                        ? sip.amfiName
                                                        : sip?.schemeName}
                                                    </p>
                                                  </div>
                                                </div>

                                                {sip?.installmentAmount && (
                                                  <p className='text-nowrap text-sm font-medium text-black-400'>
                                                    {calculateParcentage(
                                                      sip?.installmentAmount,
                                                      getTotalAmount(sips),
                                                    )}{' '}
                                                    %
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            {/* <div className='ml-4'>
                                              <Menubar className='border-0 bg-transparent p-0'>
                                                <MenubarMenu>
                                                  <MenubarTrigger asChild>
                                                    <Button
                                                      variant='ghost'
                                                      size='sm'
                                                      className='h-6 w-6 p-0 rounded-full hover:bg-gray-100 cursor-pointer'
                                                      onClick={(e) => {
                                                        e.stopPropagation()
                                                        setOpenMenubar(
                                                          openMenubar === sip.id ? null : sip.id,
                                                        )
                                                      }}
                                                    >
                                                      <MoreHorizontal className='h-4 w-4' />
                                                    </Button>
                                                  </MenubarTrigger>
                                                  <MenubarContent align='end' className='w-48'>
                                                    <MenubarItem
                                                      className='text-error-500 bg-error-50 cursor-pointer'
                                                      onClick={() => {
                                                        setShowSIPCancel(true), setSelectedSIP(sip)
                                                      }}
                                                    >
                                                      Cancel SIP
                                                    </MenubarItem>
                                                  </MenubarContent>
                                                </MenubarMenu>
                                              </Menubar>
                                            </div> */}
                                          </div>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </AccordionContent>
                              </AccordionItem>
                            ))}
                          </Accordion>
                        </>
                      ) : (
                        <SIPsEmpty
                          title='There are no basket SIPs in progress right now.'
                          description='Start your investment journey today by choosing a plan or exploring our curated funds.'
                          mainText='In-Progress Basket SIPs'
                          page='/dashboard/mutual-funds'
                          showButton={false}
                        />
                      )}
                    </div>
                  </TabsContent>

                  <TabsContent value='cancelled'>
                    <div className='max-w-[1128px] px-4 lg:px-0 mx-auto'>
                      {cancelledSips && Object.keys(cancelledSips).length > 0 ? (
                        <>
                          <div className='hidden md:flex justify-between bg-[#F4F7FE] rounded-lg pl-14'>
                            <div className='text-primary-400 text-sm font-medium py-3'>
                              Goal Name
                            </div>

                            <div className='text-primary-400 text-sm font-medium py-3 px-4'>
                              Amount
                            </div>
                          </div>
                          <Accordion type='single' collapsible className='w-full'>
                            {Object.entries(cancelledSips).map(([basketId, sips]) => (
                              <AccordionItem value={basketId} key={basketId}>
                                <AccordionTrigger className='hover:no-underline'>
                                  <div className='flex justify-between items-center w-full'>
                                    <div className='w-full'>
                                      <div className='w-full flex md:justify-between items-start md:items-center gap-x-2'>
                                        <img
                                          src={
                                            iconsList[
                                              'light' + FinancialGoalsReversed[sips[0]?.planType]
                                            ]
                                              ? iconsList[
                                                  'light' +
                                                    FinancialGoalsReversed[sips[0]?.planType]
                                                ]
                                              : `${env.SVGS}/basket.svg`
                                          }
                                          className='h-12 w-12 rounded-[8px] mt-1'
                                        />
                                        <div className='w-full'>
                                          <div className='flex justify-between gap-x-4 items-center'>
                                            <p className='font-semibold text-gray-900 text-wrap leading-6 flex items-center gap-x-2'>
                                              <span className='truncate whitespace-nowrap overflow-hidden max-w-[200px] md:max-w-max'>
                                                {' '}
                                                {sips[0]?.customerBasketName}
                                              </span>
                                            </p>
                                          </div>

                                          <p className='text-sm text-black-400'>
                                            Repeats on the{' '}
                                            <strong>
                                              {addNumberSuffix(getDate(sips[0]?.sipStartDate))}
                                            </strong>{' '}
                                            of every month
                                          </p>

                                          <div className='flex justify-between items-center'>
                                            <div className='flex gap-x-1 text-xs items-center text-black-400'>
                                              Start Date -
                                              <p className='flex justify-start text-xs items-center gap-x-1 text-center font-DMSans'>
                                                <span className='font-semibold'>
                                                  {getDate(sips[0]?.sipStartDate)}
                                                </span>
                                                <span className='font-semibold '>
                                                  {
                                                    monthShortNames[
                                                      getMonth(sips[0]?.sipStartDate) - 1
                                                    ]
                                                  }
                                                </span>
                                                <span className='font-semibold '>
                                                  {getYear(sips[0]?.sipStartDate)}
                                                </span>
                                              </p>
                                            </div>

                                            <p className='text-nowrap pr-2 md:hidden'>
                                              ₹ {toCurrency(getTotalAmount(sips))}
                                            </p>
                                          </div>
                                        </div>

                                        <div className='hidden md:flex'>
                                          <p className='text-nowrap pr-2'>
                                            ₹ {toCurrency(getTotalAmount(sips))}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </AccordionTrigger>

                                <AccordionContent>
                                  <div>
                                    {sips?.map((sip, index) => {
                                      return (
                                        <div
                                          className={`p-4 flex items-center lg:items-start w-full`}
                                          key={index}
                                        >
                                          <div className='flex justify-between items-center w-full'>
                                            <div className='flex justify-between items-center w-full'>
                                              <div className='w-full flex justify-between items-center gap-x-2'>
                                                <div className='flex gap-x-4 items-center md:w-[50%]'>
                                                  <img
                                                    src={`${env.MF_LOGOS_URL}/${sip?.amcCode}.png`}
                                                    className='h-12 w-12 rounded-[8px] mt-1'
                                                  />
                                                  <div className='w-full md:w-auto'>
                                                    <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                      {sip?.sname
                                                        ? sip.sname
                                                        : sip?.amfiName
                                                        ? sip.amfiName
                                                        : sip?.schemeName}
                                                    </p>
                                                  </div>
                                                </div>

                                                {sip?.installmentAmt && (
                                                  <p className='text-nowrap text-sm font-medium text-black-400'>
                                                    {calculateParcentage(
                                                      sip?.installmentAmt,
                                                      getTotalAmount(sips),
                                                    )}{' '}
                                                    %
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            {/* <div className='ml-4'>
                                              <Menubar className='border-0 bg-transparent p-0'>
                                                <MenubarMenu>
                                                  <MenubarTrigger asChild>
                                                    <Button
                                                      variant='ghost'
                                                      size='sm'
                                                      className='h-6 w-6 p-0 rounded-full hover:bg-gray-100 cursor-pointer'
                                                      onClick={(e) => {
                                                        e.stopPropagation()
                                                        setOpenMenubar(
                                                          openMenubar === sip.id ? null : sip.id,
                                                        )
                                                      }}
                                                    >
                                                      <MoreHorizontal className='h-4 w-4' />
                                                    </Button>
                                                  </MenubarTrigger>
                                                  <MenubarContent align='end' className='w-48'>
                                                    <MenubarItem
                                                      className='text-error-500 bg-error-50 cursor-pointer'
                                                      onClick={() => {
                                                        setShowSIPCancel(true), setSelectedSIP(sip)
                                                      }}
                                                    >
                                                      Cancel SIP
                                                    </MenubarItem>
                                                  </MenubarContent>
                                                </MenubarMenu>
                                              </Menubar>
                                            </div> */}
                                          </div>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </AccordionContent>
                              </AccordionItem>
                            ))}
                          </Accordion>
                        </>
                      ) : (
                        <SIPsEmpty
                          title='There are no cancelled basket SIPs right now.'
                          description='Start your investment journey today by choosing a plan or exploring our curated funds.'
                          mainText='Cancelled Basket SIPs'
                          page='/dashboard/mutual-funds'
                          showButton={false}
                        />
                      )}
                    </div>
                  </TabsContent>
                </Tabs>
              </div>

              <Dialog open={showSIPCancel} onOpenChange={setShowSIPCancel}>
                <DialogContent className='sm:max-w-md'>
                  <DialogHeader className='text-center space-y-4'>
                    <DialogTitle className='text-xl text-center font-normal text-black-400'>
                      Your SIP of ₹{' '}
                      <strong>
                        {toCurrency(
                          selectedSIP
                            ?.map((sip) => sip.installmentAmt)
                            .reduce((acc, curr) => acc + curr, 0),
                        )}
                      </strong>{' '}
                      will be cancelled
                    </DialogTitle>
                  </DialogHeader>

                  <div className='space-y-6 pt-4'>
                    <div className='space-y-3'>
                      <label className='text-base font-medium text-gray-900'>
                        Reason for cancellation
                      </label>
                      <Select value={selectedReason} onValueChange={setSelectedReason}>
                        <SelectTrigger className='w-full h-12 text-gray-500 border'>
                          <SelectValue placeholder='Select a reason' />
                        </SelectTrigger>
                        <SelectContent className='z-[10000]'>
                          {cancellationReasons.map((reason) => (
                            <SelectItem
                              key={reason.code}
                              value={reason.code}
                              className='py-3 cursor-pointer text-black-500 text-sm hover:bg-gray-50'
                            >
                              {reason.description}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>

                    <div className='flex gap-3 pt-4'>
                      <Button
                        variant='outline'
                        className='flex-1'
                        onClick={() => setShowSIPCancel(false)}
                      >
                        Keep SIP
                      </Button>
                      <Button
                        className='flex-1 bg-primary-600'
                        onClick={handleCancel}
                        disabled={!selectedReason}
                      >
                        Cancel SIP
                      </Button>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </>
          )}
        </div>
      )

    case 'hasError':
      return (
        <div className='bg-white flex items-center justify-center'>
          <Card className='w-full max-w-3xl text-center border-none shadow-none font-DMSans'>
            <CardHeader className='flex flex-col gap-y-6 justify-center items-center'>
              <img className='h-14 w-14' src={`${env.SVGS}/error-icon.svg`} alt='Error-Icon' />
              <CardTitle className='font-semibold text-base'>Oops! Something Went Wrong</CardTitle>
            </CardHeader>
            <CardContent className='flex flex-col gap-y-6'>
              <p className='text-sm leading-5 text-black-400 mb-6'>
                We're sorry, but it seems there was an issue connecting to our server. Please check
                your internet connection or try refreshing the page. If the problem persists, try
                again later.
              </p>
            </CardContent>
          </Card>
        </div>
      )

    default:
      return null
  }
}

export default BasketSIPs
